import { render, staticRenderFns } from "./CallbotTelephony.vue?vue&type=template&id=2102245a"
import script from "./CallbotTelephony.vue?vue&type=script&lang=ts"
export * from "./CallbotTelephony.vue?vue&type=script&lang=ts"
import style0 from "./telephony.sass?vue&type=style&index=0&prod&lang=sass&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports